import React from 'react';

import {Breadcrumbs} from '../../components/breadcrumbs';
import type {SiteRoutes} from '../../lib/routes';

import css from './tool-crumbs.module.css';

export const visuallyHidden = css.visuallyHidden;

type Props = {
	trail: Array<{title: string; route?: keyof SiteRoutes}>;
};

export const ToolCrumbs: React.FC<Props> = ({trail}) => (
	<Breadcrumbs className={css.crumbs} breadcrumbs={[{title: 'Инструменты', route: 'tools'}, ...trail]} />
);
